module.exports = __webpack_public_path__ + "img/grade2.c5e18c44.png";